/* @flow */

import * as React from 'react';
import './body.css';

type Props = {
    children?: React.Node,
    as: string,
};

Body.defaultProps = {
    as: 'span',
};

export function Body({children, as: Tag}: Props) {
    return <Tag styleName='body'>{children}</Tag>;
}
